/* istanbul ignore file */
import React, { useEffect } from "react";

/**
 * SVB - Medalia Survey Component
 * @param {object} props 
 */
export default function SVBMedaliaSurvey(props) {
    const source = process.env.REACT_APP_MEDALIA_SRC || 'https://nebula-cdn.kampyle.com/us/wu/485159/onsite/embed.js';
    useEffect(() => {
        if (props.enabled === true) {
            setTimeout(() => {
                var ms = document.createElement('script');
                ms.type = 'text/javascript'; ms.async = 1;
                ms.src = source;
                { !props.testing && document.body.appendChild(ms) }

            }, 200);

        }
    }, [])
    return <></>;
}
